// import dayjs from "dayjs";
import { ReactNode } from 'react';
import { IntlShape } from 'react-intl';

export interface DailyDishFilterModel {
  week?: number;
  /** `YYYY-MM` — khung thực đơn của năm học, KHÔNG phải số tháng của năm dương lịch. */
  month?: string;
  state?: DailyDishStatusEnum;
}

export enum DailyDishStatusEnum {
  propose = 'propose',
  confirm = 'confirm',
  complete = 'complete',
}

export const DayTitle = (intl: IntlShape) => ({
  2: intl.formatMessage({ id: 'monday' }),
  3: intl.formatMessage({ id: 'tuesday' }),
  4: intl.formatMessage({ id: 'wednesday' }),
  5: intl.formatMessage({ id: 'thursday' }),
  6: intl.formatMessage({ id: 'friday' }),
  7: intl.formatMessage({ id: 'saturday' }),
  8: intl.formatMessage({ id: 'sunday' }),
});

export const DayTitleUppercase = (intl: IntlShape) => ({
  2: intl.formatMessage({ id: 'mondayUppercase' }),
  3: intl.formatMessage({ id: 'tuesdayUppercase' }),
  4: intl.formatMessage({ id: 'wednesdayUppercase' }),
  5: intl.formatMessage({ id: 'thursdayUppercase' }),
  6: intl.formatMessage({ id: 'fridayUppercase' }),
  7: intl.formatMessage({ id: 'saturdayUppercase' }),
  8: intl.formatMessage({ id: 'sundayUppercase' }),
});

interface DayData {
  weekDay: 2 | 3 | 4 | 5 | 6;
  dishes: string[];
  afternoons: string[][];
}

export interface LayoutProps {
  days: DayData[];
  settings: TemplateSettings;
  maxCount: { lunch: number; afternoon: number };
  getDishes: <T extends string[] | string[][]>(dishes: T, limit: number) => T;
}

export interface TemplateLayout {
  id: number;
  element: ReactNode;
  desciption: string;
  type: 'Cố định' | 'Tùy chỉnh';
}

export interface FontDetails {
  fontFamilyId: number;
  /**
   * Cỡ chữ
   * Limits vary by section:
   * - weekTitle: 24-50
   * - subWeekTitle: 22-32
   * - weekdayTitle: 16-22
   * - content: 10-18
   */
  fontSize: number;
  fontColor: string;
}

type WeekdayStyle = {
  /**
   * Màu viền
   */
  borderColor: string;
  /**
   * ID emoji
   */
  emojiId: number;
};

export interface TemplateSettings {
  general: {
    /** ID bố cục */
    layoutId: number;
    /** Căn chỉnh bố cục (left/right) - chỉ áp dụng cho TwoColumnsLeft layout */
    layoutAlign: 'left' | 'right';
    /**
     * Toggle logo của HVS và khách hàng
     */
    showLogo: {
      hvs: boolean;
      client: boolean;
    };
    backgroundImage: {
      /**
       * Loại hình ảnh nền theo chủ đề
       */
      category: number;
      id: number;
    };
    /** Filename kèm đuôi trong `/menu-background_image/`, vd. `menu_bg_1.webp`. */
    backgroundFile: string | null;
    /** Nền lấy từ IndexedDB máy user. */
    localBackground: boolean;
  };
  font: {
    /**
     * Tiêu đề tuần
     */
    weekTitle: FontDetails;
    /**
     * Tiêu đề tuần phụ
     */
    subWeekTitle: FontDetails;
    /**
     * Tiêu đề ngày trong tuần
     */
    weekdayTitle: FontDetails;
    /**
     * Nội dung
     */
    content: FontDetails;
  };
  menu: {
    /**
     * Kiểu tiêu đề ngày
     */
    weekdayTitleStyle: number;
    /**
     * Vi trí tiêu đề ngày
     */
    weekdayTitlePosition: 'top' | 'bottom';
    /**
     * Độ dày viền của khung
     * Min: 0
     * Max: 20
     */
    borderWidth: number;
    /**
     * Độ bo góc của khung
     * Min: 0
     * Max: 130
     */
    borderRadius: number;
    /**
     * Hiển thị emoji
     */
    emojiEnabled: boolean;
    /**
     * Cấu hình theo ngày trong tuần
     */
    weekday: {
      2: WeekdayStyle;
      3: WeekdayStyle;
      4: WeekdayStyle;
      5: WeekdayStyle;
      6: WeekdayStyle;
      7: WeekdayStyle;
    };
  };
  favoritesList: TemplateSettings[];
}

export const defaultSettings: TemplateSettings = {
  general: {
    layoutId: 1,
    layoutAlign: 'left',
    showLogo: {
      hvs: true,
      client: true,
    },
    backgroundImage: {
      category: 1,
      id: 1,
    },
    backgroundFile: 'menu_bg_1.webp',
    localBackground: false,
  },
  font: {
    weekTitle: {
      fontFamilyId: 1,
      fontSize: 50,
      fontColor: '#283090',
    },
    subWeekTitle: {
      fontFamilyId: 1,
      fontSize: 30,
      fontColor: '#283090',
    },
    weekdayTitle: {
      fontFamilyId: 1,
      fontSize: 22,
      fontColor: '#ffffff',
    },
    content: {
      fontFamilyId: 1,
      fontSize: 18,
      fontColor: '#000000',
    },
  },
  menu: {
    weekdayTitleStyle: 1,
    weekdayTitlePosition: 'top',
    borderWidth: 10,
    borderRadius: 12,
    emojiEnabled: true,
    weekday: {
      2: {
        borderColor: '#FFAE00',
        emojiId: 1,
      },
      3: {
        borderColor: '#008DDA',
        emojiId: 1,
      },
      4: {
        borderColor: '#00B898',
        emojiId: 1,
      },
      5: {
        borderColor: '#9747FF',
        emojiId: 1,
      },
      6: {
        borderColor: '#46B52B',
        emojiId: 1,
      },
      7: {
        borderColor: '#FFEE00',
        emojiId: 1,
      },
    },
  },
  favoritesList: [],
};
